/* eslint-disable @angular-eslint/component-selector */
import { Component, Input, OnInit } from "@angular/core";
import { combineLatest, interval, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { UtilityService } from "source/app/configuration/services/utility.service";

@Component({
	selector: "last-updated",
	templateUrl: "./last-updated.component.html",
	styleUrls: ["./last-updated.component.scss"],
})
export class LastUpdatedComponent implements OnInit {
	constructor(private utilityService: UtilityService) {}

	@Input() lastUpdated: Observable<Date | string>;
	@Input() warningThreshold = 15;
	@Input() icon = "notifications-outline";

	data$: Observable<{ minutesSinceLastUpdate: number; showWarning: boolean }>;

	ngOnInit() {
		this.data$ = combineLatest([this.lastUpdated, interval(1000)]).pipe(
			map(([lastUpdated]) => {
				const minutesSinceLastUpdate = this.utilityService.getMinutesSince(lastUpdated);
				const showWarning = this.warningThreshold > 0 && minutesSinceLastUpdate >= this.warningThreshold;
				return { minutesSinceLastUpdate, showWarning };
			}),
		);
	}
}
